import {
  delayedContent,
  categoriesScrollTop,
  redirectWithDelay,
  contentLoadSlowHandler,
  btnWithSpinner,
  scrollLockByDelay
} from "./modules/delay";
import {
  quizUniverseRoundsAnimationContent,
  quizUniverseProgressAnimationContent,
  quizUniverseUserScoreAnimation
} from "./modules/quiz-universe";
import {
  trackingPixels,
  trackPages,
  trackOrientation,
  pageDepth,
  trackContentLoading,
  listenToLuckySpinEvents,
  trackEmailButtonWidgetLink,
  trackPremiumFlow,
  trackEnneagramGame,
  trackPageFocus,
  trackPageLoad,
  interPageAdsTracking,
  trackKeyGameEvents
} from "./modules/tracking";
import {
  chartAutoProgress,
  completionBarAutoProgress,
  fiftyFiftyJoker,
  handleRewardedVideo,
  handlePlayWithoutLifelines,
  handleTimer,
  handleUnlockQuestionButton,
  iqTestLandingInit,
  luckySpinOption,
  numberAutoCounter,
  showShortenText,
  handlePausePage,
  handleAnswerPageWithCompleteOption,
  handleUserAnswersVideoOption,
  saveUserDeviceWidth,
  handleQuizDailyOfferWall,
  handleShowUserAnswersGraphOnMobileAnswerPage,
  handleQuizUniverseAnswer,
  handleQuizUniverseRoundPage,
  triggerAnswerSubmitEvent,
  quizUniverseComSliderInit,
} from "./modules/flow";
import { handleScrollTop, preventDefaultButtonBehaviourAndScrollTop, setTimestampToCookies, changeBottomStickyAdPosition, handleStickyFooter } from "./modules/utils";
import { gimmemoreSubNav, langDropDown, mobileNav, handleOrganicMenuSubitems, quizUniverseNav, newGmmHomepageMenu } from "./modules/nav";
import { shareResult } from "./modules/share";
import * as facebook from "./modules/facebook";
import { notificationModal, appDownloadModal } from "./modules/modal";
import { videoPlayerSetup } from "./modules/video";
import { collectUserAnswerForQueue, sendUserAnswerToQueue, sendSpendDataToQueue } from "./modules/queue";
import { auth, toggleLoginModal } from "./modules/login";
import { profileDelete, profileSubscribe } from "./modules/profile";
import { registrationConfirmation, registrationEntry } from "./modules/registration";

//
// Components related events
//

const App = $('#GimmeApp');

const AppEvents = {
  fbError: 'FB.ERROR',
  fbShareClosed: 'FB.SHARE.CLOSED',
  fbConnected: 'FB.CONNECTED',
  fbSuccess: 'FB.SUCCESS'
};

App.on(AppEvents.fbError, (e, error) => handleResponseError(error));

//
// load facebook lib remote
//

facebook.loadLib();

//
// FB async init
//

facebook.asyncInit(App, AppEvents);

//
// Show/hide delayed content
//

delayedContent();

//
// mobile navigation
//

mobileNav();

//
// legacy gimmemore sub navigation, still using for desktop and tablet
//

gimmemoreSubNav();

//
// gimmemore organic navigation
//
handleOrganicMenuSubitems();

//
// quiz-universe nav
//
quizUniverseNav();

//
// button with spinner option
// it's inactive until loading is not over
//

btnWithSpinner();

// quiz universe functionality
quizUniverseRoundsAnimationContent();
quizUniverseProgressAnimationContent();
quizUniverseUserScoreAnimation();

newGmmHomepageMenu();
//
// on document ready
//

document.addEventListener('DOMContentLoaded', function() {
  trackPageFocus();
  langDropDown();
  trackingPixels();
  redirectWithDelay();
  trackPages();
  trackOrientation();
  pageDepth();
  notificationModal($('.intellitest-nav'), $('.intellitest-nav-modal'));
  handleScrollTop();
  preventDefaultButtonBehaviourAndScrollTop();
  handleShowUserAnswersGraphOnMobileAnswerPage();
  showShortenText();
  shareResult();
  completionBarAutoProgress();
  numberAutoCounter();
  chartAutoProgress();
  videoPlayerSetup();
  categoriesScrollTop();
  iqTestLandingInit();
  luckySpinOption();
  listenToLuckySpinEvents(App);
  handlePausePage();
  handleRewardedVideo(App);
  handlePlayWithoutLifelines();
  handleAnswerPageWithCompleteOption();
  contentLoadSlowHandler();
  handleUnlockQuestionButton();
  trackContentLoading();
  handleTimer();
  handleUserAnswersVideoOption(App);
  interPageAdsTracking();
  setTimestampToCookies();
  handleQuizDailyOfferWall();
  handleQuizUniverseRoundPage();
  handleQuizUniverseAnswer();
  triggerAnswerSubmitEvent();
  appDownloadModal();
  quizUniverseComSliderInit();

  scrollLockByDelay();
  trackEmailButtonWidgetLink();
  trackPremiumFlow();
  trackEnneagramGame();
  collectUserAnswerForQueue();
  sendUserAnswerToQueue();
  sendSpendDataToQueue();

  const $jokers = $('.joker-btn');

  if ($jokers.length) {
    for (let $joker of Array.from($jokers)) {
      notificationModal($($joker), $('.' + $joker.dataset.modal));
    }
  }

  if ($('.auto-modal').length) {
    $('.auto-modal').modal({closable: false,}).modal('show');
  }

  fiftyFiftyJoker();
  saveUserDeviceWidth();
  trackPageLoad();
  trackKeyGameEvents();

  changeBottomStickyAdPosition();
  handleStickyFooter();

  // login
  toggleLoginModal();
  auth();
  profileSubscribe();
  profileDelete();

  // registration
  registrationEntry();
  registrationConfirmation();
});
